<template>
    <div>

        <div class="body02">
            <div class="body02-1">
                <el-card class="card_gundong">
                    <el-row :gutter="0">

                        <!-- <el-col :span="10">
                            <el-radio v-model="proSelectType" label="1" border>全部</el-radio>
                            <el-radio v-model="proSelectType" label="2" border>实物商品</el-radio>
                            <el-radio v-model="proSelectType" label="3" border>储值商品</el-radio>
                        </el-col> -->
                        <el-col :span="10">
                            <productTypeSelect style="width: 240px;" @getProductTypeSelectedUid="getProductTypeSelectedUid"
                                ref="productTypeSelect" :chanpin_type="6" :key="this.datekey">
                            </productTypeSelect>

                        </el-col>
                        <el-col :span="2">
                        </el-col>
                        <el-col :span="10">
                            <el-input placeholder="请输入查询内容" v-model="queryInfo.query" class="input-with-select" clearable
                                style="width:300px " @clear="getproductList" @change="getproductList">
                                <el-button slot="append" icon="el-icon-search" @click="getproductList"></el-button>
                            </el-input>
                        </el-col>
                        <!-- <el-col :span="6">
                            <el-button type="primary" @click="get_product_add" v-if="false">出库清单</el-button>
                        </el-col> -->
                    </el-row>
                    <el-row :gutter="0" class="el_row_two">
                        <el-col :span="24">
                            <el-table :data="productList" style="width: 100%" border stripe>

                                <el-table-column prop="pro_bianhao" label=" 编号" width="150"></el-table-column>
                                <el-table-column prop="pro_name" label="名称" width="250"></el-table-column>

                                <el-table-column prop="pro_price_shichang" label="市场价">
                                </el-table-column>
                                <el-table-column prop="pro_price_huiyuan" label="会员价">
                                </el-table-column>
                                <el-table-column prop="pro_price_pifa" label="批发价"> </el-table-column>
                                <el-table-column prop="pro_price_gaoji" label="高级会员价">
                                </el-table-column>
                                <el-table-column label="操作" width="300px">
                                    <template v-slot="scope">
                                        <el-input-number v-model="scope.row.count" :min="1" :max="100000"
                                            style="width: 140px;" label="描述文字"></el-input-number>
                                        <el-button
                                            @click="kucun_chuku_add(scope.$index, scope.row.kucun_uid, scope.row.uid, scope.row.pro_bianhao, scope.row.pro_name, scope.row.pro_type, scope.row.pro_price_shichang, scope.row.pro_price_huiyuan, scope.row.pro_price_gaoji, scope.row.pro_price_pifa, scope.row.count, scope.row.pro_code)"
                                            type="primary" plain style="margin-left: 10px;">添加</el-button>
                                        <!-- 读出数量，在添加的时候，就要做数量上的判断 -->
                                    </template>
                                </el-table-column>
                            </el-table>
                        </el-col>
                    </el-row>
                </el-card>
                <!-- 分页 -->
                <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                    :current-page.sync="queryInfo.pageNum" :page-sizes="[10, 50]" :page-size="queryInfo.pageSize"
                    layout="total, sizes, prev, pager, next, jumper" :total="total">
                    <!--分页组件，其中handleSizeChange 条数下拉触发事件，  handleCurrentChange  选择分页出发事件 currentPage2 当前页绑定 page-sizes 下拉显示列表 page-size 每页多少条绑定 layout 显示分页的元素 total 合计条数绑定  -->
                </el-pagination>
            </div>
            <div class="body02-2">
                <el-card class="card_gundong002">

                    <el-card style="background-color: #dee;">

                        <span style="background-color: #ddd;width: 100%;padding: 0px;"> 组合商品编号：{{ zuhe_bianhao }}
                        </span>
                        <el-table ref="multipleTable" :data="zuheAddData" tooltip-effect="dark" style="width: 100%"
                            @selection-change="handleSelectionChange"
                            :default-sort="{ prop: 'xuhao', order: 'descending' }">
                            <el-table-column width="80" label="序号"> <template slot-scope="scope">{{ scope.$index
                            }}</template>
                            </el-table-column>
                            <!-- <el-table-column prop="proUid" label="商品序号"> </el-table-column> -->
                            <el-table-column prop="proName" label="商品名称" width="200"> </el-table-column>
                            <!-- <el-table-column label="商品类别">
                                <template slot-scope="scope">{{ scope.row.leixing01 }}:{{ scope.row.leixing02 }}:{{
                                    scope.row.leixing03 }}:{{ scope.row.leixing04 }}</template>
                            </el-table-column> -->
                            <el-table-column prop="priceShichang" label="市场价"> </el-table-column>
                            <el-table-column prop="priceHuiyuan" label="会员价"> </el-table-column>
                            <el-table-column prop="priceGaoji" label="高级会员价"> </el-table-column>
                            <el-table-column prop="pricePifa" label="批发价"> </el-table-column>
                            <el-table-column prop="proCount" label="商品数量" show-overflow-tooltip>

                            </el-table-column>
                            <el-table-column label="操作" show-overflow-tooltip>
                                <template slot-scope="scope2">
                                    <el-button @click="chuku_delete(scope2.$index, zuheAddData)" style="font-size: 22px;"
                                        type="text" icon="el-icon-remove-outline"></el-button>
                                </template>

                            </el-table-column>

                        </el-table>
                    </el-card>
                    <div style="text-align: right;font-size:25px;font-weight: 400;" v-if="kaidanFlag === 1"> 订单总额合计： <span
                            style="color: red;">{{ order_money }}</span> 元
                    </div>
                    <div style="margin-top: 20px;text-align: center;">
                        <el-button type="primary" @click="product_chuku"
                            v-if="kaidanFlag !== 1 && caozuo_type !== '1'">确定出库</el-button>
                    </div>

                </el-card>
            </div>
        </div>
        <div style="height: 1px;background-color: dimgrey;margin-bottom: 5px;" v-if="false"></div>
        <div class="price" v-if="false">
            <div>商品开单计费价格:<span class="heji"> {{ order_money }}</span>元</div>
            <div style="text-align: right;">组合名称
                <el-input v-model="zuhe_name" :min="1" :max="100000" style="width: 250px;" label="请输入名称"></el-input>
            </div>
            <div style="text-align: right;">组合销售价格
                <el-input v-model="zuhe_price" :min="1" :max="100000" style="width: 150px;" label="输入商品组合价格"></el-input>元
            </div>

        </div>
    </div>
</template>
<script>
import productTypeSelect from '../../tongyong/productType_select.vue'
import { checkMobileTest, checkSfzId } from '../config/validator';
export default {
    props: ['dataParent', 'diaoyongType', 'caozuo_type', 'productUidInfo'],

    components: {
        productTypeSelect: productTypeSelect
    },
    data() {
        return {
            datekey: Date.now(),
            guest_level_parent: 0,
            order_bianhao: '',
            kaidanFlag: 0,
            zuhe_bianhao: '',
            zuheAddData: [],
            zuheAddData_proUid: [],
            order_money: 0,
            // 获取用户列表参数
            queryInfo: {
                C_type: 'get_list_more',
                C_table_name: 'product_list04', // 04 为读取有库存的所有商品，但是不包括礼包商品
                query: '',
                pageNum: 1,
                pageSize: 10,
                CI_canshu01: this.mendianUid, // 门店qiye_uid window.sessionStorage.getItem('qiye_uid')
                CI_canshu02: this.proTypeUid, // 商品类型uid
                CI_canshu03: 1 //  1 无库存也显示 2 只显示有库存的商品
            },
            productList: [],
            //  recordCount: 0,
            total: 0,
            // 表单规则项
            addFormRules: {
                pro_name: [
                    { required: true, message: '请输入商品名称', trigger: 'blur' },
                    { min: 2, max: 20, message: '必须2到20位字符 ', trigger: 'blur' }
                ]
            },

            editFormRules: {

            },
            proTypeUid: 0, // 商品的类型uid
            proSelectType: 0, // 出售产品的时候，选择的类型，备选为1 储值商品 2 实物商品 3 组合商品 
            zuhe_name: '',
            zuhe_price: ''
        };
    },
    created() {
        this.getproductList()
       // this.zuhe_bianhao_get()
        if (this.caozuo_type === '1') return // 说明仅仅是出库操作，无需执行下面的程序
        // console.log('dataParent', this.dataParent)
        this.guest_level_parent = this.dataParent.guest_info.guest_level
        this.order_bianhao = this.dataParent.order_bianhao
        this.kaidanFlag = this.dataParent.kaidanFlag
        //  console.log(900, this.guest_level)
        // this.guest_level_parent = this.guest_level
    },
    mounted() {
        // 处理 已经设置好的数据要 复制显示出来
        var temp = {}
        const obj = this.productUidInfo.zuheProductlist // this.zuheAddData
        console.log(992, this.productUidInfo)
        if (obj === undefined) return 
        obj.forEach((item, index) => {
            temp = {
                proUid: item.uid,
                proBianhao: item.pro_bianhao,
                proName: item.pro_name,
                proType: item.pro_type,
                priceShichang: item.pro_price_shichang,
                priceHuiyuan: item.pro_price_huiyuan,
                priceGaoji: item.pro_price_gaoji,
                pricePifa: item.pro_price_pifa,
                proCount: item.pro_count,
                proCode: item.pro_code,
                proGuishuUid: this.productUidInfo.uid
            }
            this.zuheAddData.push(temp)
            console.log(993, temp)
            this.zuheAddData_proUid.push(item.uid)
        })
    },
    methods: {
        closeproductZuhe() {

        },
        getProductTypeSelectedUid(val) {
            // this.data.proTypeUid = val.productTypeSelectedUid
            this.proTypeUid = val.productTypeSelectedUid
            this.queryInfo.CI_canshu02 = this.proTypeUid
            this.getproductList()
        },
        handleSelectionChange(val) {
            this.multipleSelection = val;
        },
        //  进行产品添加
        async kucun_chuku_add(index, kucunUid, proUid, proBianhao, proName, proType, priceShichang, priceHuiyuan, priceGaoji, pricePifa, proCount, proCode) {
            // 分析商品uid 重复的 直接累加
            // 借助 zuheAddData_kucunUid 找到下标
            //  console.log(101, proPrice)
            // 库存锁定数量
            // await this.getproductList()
            console.log('kucun', index, this.productList[index].count, proUid)

            // 下标识别一定要用kucun_uid，以便后期处理库存
            const xiabiao = this.zuheAddData_proUid.indexOf(proUid) // 找到下标返回下标，没有找到返回-1
            if (xiabiao !== -1) {
                this.zuheAddData[xiabiao].proCount += proCount

                // console.log('proCount', this.zuheAddData[0].proCount)
                this.sum_order_money()
                return
            }
            // 
            var dataAdd = {
                proUid: proUid,
                proBianhao: proBianhao,
                proName: proName,
                proType: proType,
                priceShichang: priceShichang,
                priceHuiyuan: priceHuiyuan,
                priceGaoji: priceGaoji,
                pricePifa: pricePifa,
                proCount: proCount,
                proCode: proCode,
                proGuishuUid: this.productUidInfo.uid
            }
            console.log('test', dataAdd)
            this.zuheAddData.push(dataAdd)
            this.zuheAddData_proUid.push(proUid)

            this.sum_order_money()
        },
        chuku_count_input() {

        },
        sum_order_money() {
            var sum = 0
            const obj = this.zuheAddData
            obj.forEach((item, index) => {
                sum += item.proPrice * item.proCount
            })
            this.order_money = sum
        },
        async zuhe_bianhao_get(proUid, proCount) {
            const { data: res } = await this.$http.get('get_api', {
                params: { C_type: 'get_bianhao', C_table_type: 22 }
            })
            this.zuhe_bianhao = JSON.parse(res.data)[0].bianhao_l
        },
        async getproductList() {
            const { data: res } = await this.$http.get('get_api', {
                params: this.queryInfo
            });
            console.log(1110, JSON.parse(res.data)[0].dataList)
            this.productList = JSON.parse(res.data)[0].dataList
            if (!this.productList) return;
            this.productList.forEach(function (item) {
                item.yong_flag = item.yong_flag === 1;
            });
            this.total = JSON.parse(res.data)[0].total;
        },
        //  分页第一项下拉触发

        handleSizeChange(newSize) {
            this.queryInfo.pageSize = newSize;
            this.getproductList();
        },
        // 选择页数触发
        handleCurrentChange(newPage) {
            this.queryInfo.pageNum = newPage;
            this.getproductList();
        },
        async zuheShangpinAdd(callback) {
            var errFlag = await this.test_input()
            // console.log('errflag', errFlag)
            if (errFlag === 1) {
                if (this.kaidanFlag === 1) callback(errFlag)
                // else this.addDialogVisible = false 
                return
            }
            var deleteData = {
                C_type: 'product_zuhe_mingxi_delete',
                guishu_pro_uid: this.productUidInfo.uid
            }
            const { data: res } = await this.$http.post('api', deleteData)
            // 针对批次不一样的，需要弹窗做出选择，然后进行扣除
            // var zuheUid = JSON.parse(res.data)[0].zuheUid
            const obj = this.zuheAddData
            console.log(obj)
            obj.forEach((item, index) => {
                console.log(9999, item)
                const data = {
                    C_type: 'product_zuhe_mingxi_add',
                    pro_uid: item.proUid,
                    pro_count: item.proCount,
                    pro_price: item.proPrice,
                    zuhe_uid: item.proGuishuUid
                }
                const { data: res02 } = this.$http.post('api', data);
            })
            this.$message.success('保存成功');
            this.getproductList()
            this.input_init()
            this.$emit('closeAdd', '')
            // if (this.kaidanFlag === 1) callback(zuheUid)
            // if (this.kaidanFlag === 0) this.$emit('closeAdd', '');
        },
        async product_kaidan(callback) {
            // var kaidanData = {
            //     C_type: 'order_add',
            //     count: this.zuheAddData.length,
            //     zuhe_bianhao: this.zuhe_bianhao,
            //     chuku_type: this.kaidanFlag,
            //     order_money: this.order_money,
            //     order_money_dikou: 0,
            //     order_money_shengyu: this.order_money,
            //     order_bianhao: this.order_bianhao,
            //     chuku_pro_list: []
            //     // 在此不计算 抵扣金额，和剩余金额，要在结算的时候，选择结算类型，然后进行结算
            // }
            // var errFlag = await this.test_input()
            // if (errFlag === 1) {
            //     callback(errFlag, kaidanData)
            //     return
            // }
            var errFlag = 0
            const obj = this.zuheAddData
            //   console.log(999, obj)
            obj.forEach((item, index) => {
                // 因为此处是销售开单，所需要的商品数量和价格 都是经过筛选的，需要重新写一次开单数组，并callback 回主函数
                // 要返回开单的订单json递交数据库的  
                const data = {
                    C_type: 'product_zuhe_mingxi_add',
                    pro_uid: item.proUid,
                    pro_count: item.proCount,
                    pro_guishu_uid: item.proGuishuUid
                }
                this.$http.post('api', this.data)
                callback(errFlag, data)
            })
        },
        async test_input() {
            if (this.zuheAddData.length === 0) {
                this.$message.error('请录入商品及数量后再行递交！')
                return 1
            }
            const comfirmResult = await this.$confirm(
                '确定组合一下商品并保存, 是否继续?',
                '提示',
                {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }
            ).catch(err => err);
            if (comfirmResult === 'cancel') return 1
            else return 0
        },
        input_init() {
            this.getproductList()
            this.zuheAddData = []
            this.zuheAddData_proUid = []
           // this.zuhe_bianhao_get()
        },
        async productInfo(uid) {
            const { data: res } = await this.$http.get('get_api', {
                params: { C_table_name: 'product_info', uid: uid, C_type: 'get_info' }
            });
            // console.log(JSON.parse(res.data))
            console.log(res.data);
            if (JSON.parse(res.data)[0].status !== 200) {
                return this.$message.error('读取失败');
            }
            this.editForm = JSON.parse(res.data)[0].data[0];
            console.log(700, this.editForm)
        },
        async chuku_delete(index, rows) {
            console.log(803, index, rows)
            const comfirmResult = await this.$confirm(
                '确定删除该条记录, 是否继续?',
                '提示',
                {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }
            ).catch(err => err);
            console.log(804, comfirmResult);
            if (comfirmResult === 'cancel') return this.$message.info('已经取消删除');
            rows.splice(index, 1)
           this.zuheAddData_proUid.splice(index, 1) 
            this.sum_order_money()
        }
    }
}
</script>
<style lang="less" scoped>
.card_two {
    margin-top: 30px;
    box-shadow: none !important;
    background-color: #f2f6fc;
}

.el_row_two {
    margin-top: 30px;
}

.card_gundong {
    height: 500px;
    overflow-y: auto;
}

.card_gundong002 {
    height: 500px;
    overflow-y: auto;
}

.body02 {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
}

.body02-1 {
    width: 50%;
}

.body02-2 {
    width: 50%;
}

.price {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    width: 800px;
}

.heji {
    font-size: large;
    font-weight: 400;
    color: crimson;
    margin-left: 20px;
    margin-right: 20px;
}
</style>
